import { render } from "./SocialModal.vue?vue&type=template&id=32ee98b0&scoped=true"
import script from "./SocialModal.vue?vue&type=script&lang=js"
export * from "./SocialModal.vue?vue&type=script&lang=js"

import "./SocialModal.vue?vue&type=style&index=0&id=32ee98b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ee98b0"]])

export default __exports__